import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { type FetchPartnerToSubPartnersQuery } from '@/features/partner-to-sub-partners/api'
import { type PartnerToSubPartnerEntity } from '@/libs/api'

import { getSubPartnersSelectQueryOptions } from '../query-options'

/**
 * Select用の運送会社ー一覧のUseQuery
 */
export const useSubPartnersSelectQuery = (
  query: FetchPartnerToSubPartnersQuery,
  options?: {
    disabled: boolean
  }
): UseQueryResult<PartnerToSubPartnerEntity[]> => {
  const disabled = options?.disabled ?? false
  return useQuery<PartnerToSubPartnerEntity[]>({
    ...getSubPartnersSelectQueryOptions(query),
    enabled: !disabled,
    retry: false
  })
}
